import { computed, ref } from 'vue';
import { createGlobalState } from '@vueuse/core';
import type { IPackageType } from '@eureka/services/src/apis/common.api.types';
import { packageInfoDeferred, getIfHasTrialPackage } from '@eureka/utils/package-info';

export const usePackageInfo = createGlobalState(() => {
  const packageInfo = ref<IPackageType[]>([]);
  const isPackageInfoReady = ref(false);

  async function fetchPackageInfo() {
    isPackageInfoReady.value = false;
    const packages = await packageInfoDeferred.promise;
    packageInfo.value = packages;
    isPackageInfoReady.value = true;
  }

  const hasTrialPackage = computed(() => {
    return getIfHasTrialPackage(packageInfo.value);
  });

  fetchPackageInfo();

  return {
    packageInfo,
    hasTrialPackage,
    fetchPackageInfo,
    isPackageInfoReady,
  };
});
